import {ExclamationTriangleIcon, CheckCircleIcon} from '@heroicons/react/24/outline';

export function calculateTop5Share(paymentsData, totalPaid) {

  const top5Performers = [...paymentsData]
    .sort((a, b) => b.month_payment - a.month_payment)
    .slice(0, 5);

  const top5TotalPayment = top5Performers.reduce((sum, user) => sum + user.month_payment, 0);
  const top5SharePercent = totalPaid > 0 ? (top5TotalPayment / totalPaid) * 100 : 0;

  let performanceNote = '';
  let performanceColor = '';

  if (top5SharePercent >= 40) {
    performanceNote = 'Top 5 ranking users received a very good share';
    performanceColor = 'text-green-800';
  } else if (top5SharePercent >= 25) {
    performanceNote = 'Top 5 ranking users received a fair share';
    performanceColor = 'text-yellow-700';
  } else {
    performanceNote = 'Top 5 ranking users might be underpaid';
    performanceColor = 'text-red-800';
  }

  return {
    top5SharePercent,
    performanceNote,
    performanceColor,
  };
}

export function getPaymentConfirmationInfo(selectedUsersCount, totalUsersCount, hasPaymentSubmitted, paymentRequirements, top5SharePercent, validationSummary = undefined) {
  const warnings = [];

  const hasExcluded = selectedUsersCount < totalUsersCount;

  if (paymentRequirements && paymentRequirements.full_month === false) {
    warnings.push({
      type: "warning",
      label: "Month not complete",
      description: <>There are missing scores <span className="text-red-800"><strong>{paymentRequirements.max_nr_scores}/{paymentRequirements.max_nr_expected_scores}</strong></span></>
    });
  }

  // Payment already submitted
  if (hasPaymentSubmitted) {
    warnings.push({
      type: "error",
      label: "Payment already submitted",
      description: "Payment details were already submitted for this period and resource."
    });
  }

  // Some users are excluded
  if (hasExcluded) {
    warnings.push({
      type: "warning",
      label: "Some users are excluded",
      description: "You excluded some users from receiving payment details."
    });
  }

  // Top 5 underpaid (bonus warning)
  if (top5SharePercent < 25) {
    warnings.push({
      type: "info",
      label: "Top 5 performers might be underpaid",
      description: "The share for top performers is quite low this month."
    });
  }

  // Validation results (Task 11: send-email gate)
  let requireAcknowledge = false;
  if (validationSummary === null) {
    warnings.push({
      type: "warning",
      label: "Validations not run",
      description: "Payment validations have not been run for this month."
    });
  } else if (validationSummary && validationSummary.fail > 0) {
    warnings.push({
      type: "error",
      label: "Payment validation failed",
      description: `${validationSummary.fail} payment validation check(s) FAILED for this month. Review the validation panel before sending.`
    });
    requireAcknowledge = true;
  } else if (validationSummary && validationSummary.warn > 0) {
    warnings.push({
      type: "warning",
      label: "Payment validation warnings",
      description: `${validationSummary.warn} payment validation warning(s) for this month.`
    });
  }

  // Return confirmation info
  // Determine status
  const hasError = warnings.some(w => w.type === "error");
  const hasWarningOrInfo = warnings.some(w => w.type === "warning" || w.type === "info");

  let icon = CheckCircleIcon;
  let iconBg = "bg-green-100";
  let iconColor = "text-green-600";

  if (hasError) {
    icon = ExclamationTriangleIcon;
    iconBg = "bg-red-100";
    iconColor = "text-red-600";
  } else if (hasWarningOrInfo) {
    icon = ExclamationTriangleIcon;
    iconBg = "bg-yellow-100";
    iconColor = "text-yellow-600";
  }

  return {
    title: "Send payment details",
    warnings,
    icon,
    iconBg,
    iconColor,
    requireAcknowledge,
  };
}